import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Methods } from "../../Constants/ApiConstants";
import { EndPoints } from "../../Constants/endpoints";
import { GeneralResponse } from "../../interface/GeneralResponse";
import { setUserDetails } from "../../redux/reducers/registrationSlice";
import {
  setPassedOptional,
  setRegistrationComplete,
  setToken,
  setUserAuthenticated,
} from "../../redux/reducers/userSlice";
import { useToast } from "../../Services/ToastContext";
import Api from "../generalApi/Api";

interface LoginRequest {
  Identification: string;
  Password: string;
}

interface UseLoginMutationProps {
  onSuccessCallback?: () => void;
}

const useLoginMutation = ({
  onSuccessCallback,
}: UseLoginMutationProps = {}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const mutation = useMutation({
    mutationFn: (data: LoginRequest): Promise<GeneralResponse> => {
      return Api<LoginRequest, GeneralResponse>({
        method: Methods.POST,
        endpoint: EndPoints.Login,
        body: data,
      });
    },
    onSuccess: (response) => {
      if (response.Status) {
        localStorage.setItem("token", response.Data.Token);
        dispatch(setToken(response.Data.Token));
        dispatch(setUserAuthenticated(true));
        dispatch(setRegistrationComplete(response.Data.IsCompleted));
        dispatch(setPassedOptional(response.Data.IsCompleted));
        dispatch(
          setUserDetails({
          ...response?.Data
          }),
        );

        if (onSuccessCallback) {
          onSuccessCallback();
        } else { 
          if (response.Data.IsCompleted) {
            navigate("/", { replace: true }); 
          } else {
            navigate("/select-account-type");  
          }
        }
      } else {
        throw new Error(response.ErrorMessage || "Login Error");
      }
    },
    onError: (error) => {
      showToast(error.message, "error");
    },
  });

  return mutation;
};

export default useLoginMutation;
